<template>
  <section class="trust-logos">
    <div class="trust-logos__container">
      <p class="trust-logos__label">
        Empresas que confían en ThunderLabs
      </p>
      <div class="trust-logos__grid">
        <div 
          class="trust-logos__item" 
          :class="{ 'trust-logos__item--light': logo.light }"
          v-for="logo in logos" 
          :key="logo.name"
        >
          <img 
            :src="logo.src" 
            :alt="logo.name"
            class="trust-logos__logo"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const logos = [
  { 
    name: 'Club Hípico de Santiago', 
    src: 'https://static.clubhipico.cl/assets/img/logo_horizontal_white.svg',
    light: true
  },
  { 
    name: 'ITPGroup', 
    src: 'https://www.itpgroup.cl/assets/itp_logo-Ben6x_Pg.png' 
  },
  { 
    name: 'Duoc UC', 
    src: 'https://www.duoc.cl/wp-content/themes/wordpress-duoc-cl/images/logo-duoc.svg',
    light: true
  },
  { 
    name: 'Petfind', 
    src: 'https://petfind.cl/cdn/shop/files/Petfind_logo_1.png' 
  },
  { 
    name: 'BWTech', 
    src: 'https://www.bwtech.cl/images/logo.png' 
  },
];
</script>

<style lang="scss" scoped>
@import '@/design-system/variables';

.trust-logos {
  padding: $tl-space-12 0;
  background: $tl-gray-50;
  border-top: 1px solid $tl-gray-100;
  border-bottom: 1px solid $tl-gray-100;
}

.trust-logos__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 $tl-space-6;
  text-align: center;
}

.trust-logos__label {
  font-size: $tl-font-size-sm;
  color: $tl-gray-500;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: $tl-space-8;
  font-weight: $tl-font-weight-medium;
}

.trust-logos__grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: $tl-space-10;
  
  @media (max-width: 768px) {
    gap: $tl-space-6;
  }
}

.trust-logos__item {
  opacity: 0.7;
  transition: all 0.3s ease;
  filter: grayscale(100%);
  
  &:hover {
    opacity: 1;
    filter: grayscale(0%);
  }
  
  // For white/light logos that need to be inverted to be visible
  &--light {
    filter: grayscale(100%) invert(1) brightness(0.4);
    
    &:hover {
      filter: invert(1) brightness(0.3);
    }
  }
}

.trust-logos__logo {
  height: 40px;
  width: auto;
  max-width: 150px;
  object-fit: contain;
  
  @media (max-width: 768px) {
    height: 32px;
    max-width: 120px;
  }
}
</style>
